import styled from '@olxeu-a2b/ui/src/theme/styled';
import { Paragraph3 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';

const Tracking = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
`;

const TrackingTitle = styled(Paragraph3)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

const TrackingInfo = styled.div`
  display: inline;
  height: max-content;
  flex-grow: 1;
  margin-top: 8px;
`;

const TrackingPackageInfo = styled.div`
  display: inline;
  font-size: ${({ theme }) => theme.sizes.semiLarge};
  text-decoration: underline;
`;

const TrackingNumber = styled.span`
  display: flex;
  flex-flow: column;
  align-content: end;
  align-items: flex-end;
`;

const TrackingLink = styled.a`
  color: ${({ theme }) => theme.colors.linkPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

const TrackingInfoDesc = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.sizes.m};
  width: 100%;
`;

const TrackingLabel = styled.div`
  flex-grow: 1;
  width: 100%;
  text-align: end;
  margin-top: 16px;
`;

const TrackingLabelLink = styled(ButtonTertiaryDark)`
  padding: 0;
`;

export default {
  Tracking,
  TrackingTitle,
  TrackingInfo,
  TrackingPackageInfo,
  TrackingNumber,
  TrackingLink,
  TrackingInfoDesc,
  TrackingLabel,
  TrackingLabelLink,
};
